(function () {
    'use strict';

    angular.module("imApp").factory("metaTableDataService", ['$ihttp', function ($ihttp) {
        let service = {
            getMetaTableData: function (parms) {
                return $ihttp.post({
                    method: 2386,
                    parameters: parms || {}
                });
            },
            listMetaColumns: function (parms) {
                return $ihttp.post({
                    method: 2389,
                    parameters: parms || {}
                });
            },
            saveSelected: function (parms) {
                return $ihttp.post({
                    method: 2390,
                    parameters: parms
                });
            }
        };

        return service;
    }]);
})();
